export default __webpack_public_path__ + "static/media/front-silhouette.f090418a.svg";